// Vendors
import $ from 'jquery';

document.addEventListener(
  'wpcf7invalid',
  function (event) {
    setTimeout(function () {
      $('html')
        .stop()
        .animate(
          {
            scrollTop: $('.wpcf7-not-valid').eq(0).offset().top - 140
          },
          500,
          'swing'
        );
    }, 100);
  },
  false
);

$('input[type=radio][name=catalog_option]').on('change', function () {
  switch ($(this).val()) {
    case 'Email Catalog':
      $('#request-catalog-address-fields').addClass('u--display-none');
      break;
    case 'Request a Catalog by Mail':
      $('#request-catalog-address-fields').removeClass('u--display-none');
      break;
  }
});

$(document).ready(function () {
  var wpcf7Elm = document.querySelector('.wpcf7');
  wpcf7Elm.addEventListener(
    'wpcf7submit',
    function (event) {
      setTimeout(function () {
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('.wpcf7-response-output').offset().top - 100
          },
          500
        );
      }, 500);
    },
    false
  );
});
